function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.50449 20.071c0-10.775 8.7478-19.523 19.523-19.523 10.813 0 19.523 8.7478 19.523 19.523 0 10.813-8.7102 19.523-19.523 19.523-10.775 0-19.523-8.7102-19.523-19.523z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.50449 20.071c0-10.775 8.7478-19.523 19.523-19.523 10.813 0 19.523 8.7478 19.523 19.523 0 10.813-8.7102 19.523-19.523 19.523-10.775 0-19.523-8.7102-19.523-19.523",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9.3333
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.566 14.927c0-1.8772 1.5393-3.4165 3.4165-3.4165h16.031c1.8772 0 3.379 1.5393 3.379 3.4165v13.628c0 1.8772-1.5018 3.379-3.379 3.379h-16.031c-1.8772 0-3.4165-1.5018-3.4165-3.379z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.566 14.927c0-1.8772 1.5393-3.4165 3.4165-3.4165h16.031c1.8772 0 3.379 1.5393 3.379 3.4165v13.628c0 1.8772-1.5018 3.379-3.379 3.379h-16.031c-1.8772 0-3.4165-1.5018-3.4165-3.379z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".6007px"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m13.983 11.511h15.994c1.9147 0 3.4165 1.5393 3.4165 3.379v3.8295h-22.827v-3.8295c0-1.8397 1.5393-3.379 3.4165-3.379z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m13.983 11.511h15.994c1.9147 0 3.4165 1.5393 3.4165 3.379v3.8295h-22.827v-3.8295c0-1.8397 1.5393-3.379 3.4165-3.379z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".6007px"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m6.6617 11.623c0-1.8772 1.5393-3.4165 3.4165-3.4165h16.031c1.8772 0 3.379 1.5393 3.379 3.4165v13.628c0 1.8772-1.5018 3.379-3.379 3.379h-16.031c-1.8772 0-3.4165-1.5018-3.4165-3.379z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m6.6617 11.623c0-1.8772 1.5393-3.4165 3.4165-3.4165h16.031c1.8772 0 3.379 1.5393 3.379 3.4165v13.628c0 1.8772-1.5018 3.379-3.379 3.379h-16.031c-1.8772 0-3.4165-1.5018-3.4165-3.379z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".6007px"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.078 8.2068h15.994c1.9147 0 3.4165 1.5393 3.4165 3.4541v3.9046h-22.827v-3.9046c0-1.9147 1.5393-3.4541 3.4165-3.4541z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.078 8.2068h15.994c1.9147 0 3.4165 1.5393 3.4165 3.4541v3.9046h-22.827v-3.9046c0-1.9147 1.5393-3.4541 3.4165-3.4541z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".6007px"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.867 11.173c0-0.22526 0.18772-0.41298 0.41298-0.41298h13.929c0.22526 0 0.37544 0.18772 0.37544 0.41298v1.6144c0 0.22526-0.15018 0.37544-0.37544 0.37544h-13.929c-0.22526 0-0.41298-0.15018-0.41298-0.37544z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.867 11.173c0-0.22526 0.18772-0.41298 0.41298-0.41298h13.929c0.22526 0 0.37544 0.18772 0.37544 0.41298v1.6144c0 0.22526-0.15018 0.37544-0.37544 0.37544h-13.929c-0.22526 0-0.41298-0.15018-0.41298-0.37544z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".6007px"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11.317 18.118v3.0035h2.8533v-3.0035z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11.317 18.118h2.8533v3.0035h-2.8533z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".6007px"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m17.324 19.62h7.9593",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: ".6007px"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11.317 23.375v3.0035h2.8533v-3.0035z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "m11.317 23.375h2.8533v3.0035h-2.8533z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".6007px"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "m17.324 24.876h7.9593",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: ".6007px"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "m10.566 14.927c0-1.8772 1.5393-3.4165 3.4165-3.4165h16.031c1.8772 0 3.379 1.5393 3.379 3.4165v13.628c0 1.8772-1.5018 3.379-3.379 3.379h-16.031c-1.8772 0-3.4165-0.71767-3.4165-2.5949z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m10.638 15.03c-0.01743-1.9299 1.5384-3.5126 3.4145-3.5126h16.022c1.8761 0 3.3769 1.5826 3.3769 3.5126v14.012c0 1.93-1.5009 3.474-3.3769 3.474h-16.022c-1.8761 0-3.2664-1.0867-3.2838-3.0166z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m13.983 11.511h15.994c1.9147 0 3.4165 1.5393 3.4165 3.379v3.8295h-22.827v-3.8295c0-1.8397 1.5393-3.379 3.4165-3.379z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m13.98 11.507h16c1.9154 0 3.4178 1.5132 3.4178 3.3216v3.7645h-22.835v-3.7645c0-1.8084 1.5399-3.3216 3.4178-3.3216z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "m6.6617 11.623c0-1.8772 1.5393-3.4165 3.4165-3.4165h16.031c1.8772 0 3.379 1.5393 3.379 3.4165v13.628c0 1.8772-1.5036 3.2952-3.379 3.379l-16.097 0.71875c-1.8753 0.083738-3.3512-2.2205-3.3512-4.0977z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m10.078 8.2068h15.994c1.9147 0 3.4165 1.5393 3.4165 3.4541v3.9046h-22.827v-3.9046c0-1.9147 1.5393-3.4541 3.4165-3.4541z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref26 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#adb9ca",
  fillRule: "evenodd"
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m10.867 11.173c0-0.22526 0.18272-0.41298 0.40198-0.41298h13.558c0.21926 0 0.36544 0.18772 0.36544 0.41298v1.6144c0 0.22526-0.14618 0.37544-0.36544 0.37544h-13.558c-0.21926 0-0.40198-0.15018-0.40198-0.37544z"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m11.317 18.707v1.6967h2.2653v-1.6967z"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m11.448 23.505v1.9581h2.0039v-1.9581z"
}));

var _ref27 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060"
}, React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "m6.6015 12.193c0-1.9003 1.5518-3.4585 3.4443-3.4585h16.162c1.8925 0 3.4065 1.5582 3.4065 3.4585v13.796c0 1.9003-1.514 3.4205-3.4065 3.4205h-16.162c-1.8925 0-3.4443-1.5202-3.4443-3.4205z",
  strokeMiterlimit: 9.3333
}), React.createElement("path", {
  d: "m10.071 8.4579h16.008c1.9165 0 3.4196 1.4753 3.4196 3.3104v3.7421h-22.847v-3.7421c0-1.8351 1.5407-3.3104 3.4196-3.3104z",
  strokeMiterlimit: 9.3333,
  strokeWidth: 0.97942
}), React.createElement("path", {
  d: "m10.468 10.997c0-0.27542 0.19204-0.50494 0.4225-0.50494h14.25c0.23045 0 0.38409 0.22952 0.38409 0.50494v1.9739c0 0.27542-0.15364 0.45904-0.38409 0.45904h-14.25c-0.23045 0-0.4225-0.18361-0.4225-0.45904z",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "m11.491 18.488h2.048v2.0675h-2.048z",
  strokeMiterlimit: 9
})), React.createElement("g", {
  strokeMiterlimit: 9
}, React.createElement("path", {
  d: "m17.128 19.49h8.8088",
  strokeWidth: 1.052
}), React.createElement("path", {
  d: "m11.601 23.543h1.8645v1.9626h-1.8645z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "m16.998 24.55h8.8741",
  strokeWidth: 1.0559
})));

var SvgSurveyModelTabModels = function SvgSurveyModelTabModels(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabModels, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Models.85b82d4d.svg";
export { ForwardRef as ReactComponent };